import { Config } from '@leverege/plugin';
import { GlobalState, UI } from '@leverege/ui-redux';
export default {
  id: 'molten.IntercomLogin',
  sort: 100,
  onLoggedIn: async (molten, action) => {
    const appId = Config.get('Intercom', 'appId');
    if (appId) {
      try {
        const intercomAttributes = await Config.get('Intercom', 'getLoginAttributes', defaultGetLoginAttributes)(molten, action);
        window.Intercom?.('update', intercomAttributes);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to set intercom login attributes', err);
      }
    }
  },
  onLoggedOut: () => {
    const appId = Config.get('Intercom', 'appId');
    if (appId) {
      window?.Intercom('shutdown');
    }
  }
};
async function defaultGetLoginAttributes(molten, loginAction) {
  const {
    profile
  } = loginAction;
  const state = GlobalState.get();
  const projectId = molten.getConfig('api/projectId');
  const uiName = molten.getConfig('uiName');
  const activePersona = UI.get(state).activePersona;
  return {
    name: profile.name,
    username: profile.username,
    email: profile.email,
    phone: profile.phone,
    role: activePersona.name,
    project_id: projectId,
    ui_name: uiName
  };
}